/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { gponModels } from '../../utils/accountEquipmentValidators';

export const serialNumberMaxLength = 15;

class GponEquipmentSelect extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.handleSerialNumberChanged = this
            .handleSerialNumberChanged
            .bind(this);
        this.handleEquipmentModelChanged = this
            .handleEquipmentModelChanged
            .bind(this);
        this.getEquipmentOptions = this
            .getEquipmentOptions
            .bind(this);
        this.reset = this
            .reset
            .bind(this);
        this.handleModeChanged = this
            .handleModeChanged
            .bind(this);
    }

    reset(e) {
        e.preventDefault();
        const { orderId, workOrderActions, outlet } = this.props;
        workOrderActions.outletUpdate({
            orderId: orderId,
            newModel: outlet.get('originalModel'),
            newSerialNumber: outlet.get('originalSerialNumber'),
            outletId: outlet.get('equipmentOutlet')
        });
    }

    handleSerialNumberChanged(e) {
        const { orderId, workOrderActions, outlet } = this.props;

        const newSerialNumber = e.target.value ? e.target.value.toUpperCase() : "";
        if (newSerialNumber.length <= serialNumberMaxLength) {
            workOrderActions.outletUpdate({
                orderId: orderId,
                newSerialNumber: newSerialNumber,
                outletId: outlet.get('equipmentOutlet')
            });
        }
    }

    handleEquipmentModelChanged(e) {
        const { orderId, workOrderActions, outlet } = this.props;
        workOrderActions.outletUpdate({
            orderId: orderId,
            newModel: e.target.value,
            outletId: outlet.get('equipmentOutlet')
        });
    }

    handleModeChanged(e) {
        const { orderId, workOrderActions, outlet } = this.props;
        workOrderActions.outletUpdate({
            orderId: orderId,
            newMode: e.target.value,
            outletId: outlet.get('equipmentOutlet')
        });
    }

    getEquipmentOptions() {
        const { outlet } = this.props;

        const gponModelOptions = gponModels.map((model, index) => {
            return (
                <option
                    style={{
                        fontSize: '10px'
                    }}
                    key={`tech_equip_${index}`}
                    value={model || ''}
                    disabled={false}>
                    {outlet.get('originalModel') === model ? "Current: " + model : model}
                </option>
            );
        });

        if (!outlet.get('originalSerialNumber')) {
            gponModelOptions.push(<option
                value={'none'}
                key={`tech_equip_none`}
                style={{
                    fontSize: '10px'
                }}
                disabled={false}
                defaultValue={true}
            >
                Current: None </option>
            );
        }

        return gponModelOptions;
    }

    render() {
        const { outlet, equipmentValidations, customerDetails } = this.props;

        let serialNumberComponent = null;

        let errorMessage = "";
        if (equipmentValidations && equipmentValidations.get("gponSerialNumberValidator")) {
            errorMessage = equipmentValidations.get("gponSerialNumberValidator").isValid ? "" : "*Serial number can have max 15 alphanumerical characters";
        }

        if (outlet.get("model")) {
            serialNumberComponent = <div>
                <TextField
                    disabled={false}
                    hintText="Serial Number"
                    value={outlet.get('seriaNumber')}
                    onChange={this.handleSerialNumberChanged}
                    multiLine={false}
                    rows={1} />
                <br />
                <b>Enter FASN/SSID number here</b>
            </div>

        }
        let modeComponent = <div>
            <b>Mode</b>
            <select
                disabled={false}
                className="browser-default"
                value={outlet.get('mode') || 'none'}
                onChange={this.handleModeChanged}>
                <option>Bridge (BR)</option>
                <option>Gateway (GW)</option>
            </select>
        </div>
        return (<div>
            <select
                disabled={false}
                className="browser-default"
                value={outlet.get('model') || 'none'}
                onChange={this.handleEquipmentModelChanged}>
                {this.getEquipmentOptions()}
            </select>
            {serialNumberComponent}
            <br />
            {customerDetails.get('signalAccessCode') === 'F' && modeComponent}
        </div>);
    }
}

GponEquipmentSelect.propTypes = {
    outlet: PropTypes.object,
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object,
};

export default GponEquipmentSelect;



// WEBPACK FOOTER //
// ./src/components/equipment/GponEquipmentSelect.js